import { Button, TextField } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import React, { useEffect, useState } from "react";
import RadioBox from "Components/FormControl/RadioBox/RadioBox";
import TextArea from "Components/FormControl/TextArea/TextArea";
// SCSS
import styles from "./cancelNote.module.scss";
import { getReasonTypeList } from "api/order";
import { useFormikContext } from "formik";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ModalWithReasons = ({
  showModal,
  pageTitle,
  handleCancelClick,
  handleSubmitClick,
  placeholder,
  totalRefundAmount = 0,
}) => {
  const [comment, setComment] = useState("");
  const [error, setErrorMessage] = useState("");
  const [reasonTypeList, setReasonTypeList] = useState([]);
  const [selectedReasonSubType, setSelectedReasonSubType] = useState(null);
  const { setValues, values } = useFormikContext();

  const setRefundReasonValue = (value) => {
    setValues((val)=>{
      return {
        ...val,
        refund_reason: {
          ...val.refund_reason,
          ...value,
        }
      }
    })
  }

  useEffect(() => {
    if(showModal){
      setComment("");
      const defaultReasonType = reasonTypeList[0];
      setSelectedReasonSubType(defaultReasonType?.reason_subtypes[0]);
      setRefundReasonValue({
        reason_type_id: defaultReasonType?.id || null,
        reason_subtype_id: defaultReasonType?.reason_subtypes[0]?.id || null,
        reason_team: defaultReasonType?.reason_subtypes[0]?.team || "",
        reason_responsible_person: defaultReasonType?.reason_subtypes[0]?.responsible_person || "",
        reason_subtype_name: defaultReasonType?.reason_subtypes[0]?.name || "",
      });
    }
  }, [showModal]);

  const submit = (e) => {
    if (selectedReasonSubType?.is_comment_required && comment === "") {
      setErrorMessage(`Please write what is the issue with the ${ selectedReasonSubType?.name }.`);
    } else {
      setErrorMessage("");
      handleSubmitClick();
    }
  };
  const handleSelectedReason = (newType) => {
    setSelectedReasonSubType(newType?.reason_subtypes[0]);
    setComment("");
  };

  // Get reason types list
  const getReasonTypesList = async () => {
    const response = await getReasonTypeList();
    setReasonTypeList(response.data.data);
  };

  const handleSelectedReasonSubType = (newSubType) => {
    setSelectedReasonSubType(newSubType);
  };

  useEffect(() => {
    getReasonTypesList();
  }, []);
  
  return (
    <React.Fragment>
      <Dialog
        open={showModal}
        TransitionComponent={Transition}
        onClose={handleCancelClick}
        classes={{
          paper: styles.modalDialog,
        }}
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
      >
        <DialogContent className={`${styles.modalContent} px-4 py-0 pb-3`}>
          <div className={`text-center ${styles.modalBody}`}>
            <h5 className={`my-3 text-center ${styles.modalTitle}`}>
              {pageTitle}
            </h5>
            {pageTitle === "Replace Order" && <h3 className="text-center px-5" style={{fontSize : "20px"}}>{`Replacing an order will allow you to send a replacement without charging the customer again`}</h3>}
            <div className={`row flex-column px-2 ${styles.reasonCard_radio_button}`}>
              <h3 className="text-left">{`Please carefully select the reason you are ${placeholder ? placeholder : "cancelling"} the order`}</h3>
              {reasonTypeList.map((reasonType) => (
                <div className="row">
                  <RadioBox
                    selectedValue={values.refund_reason.reason_type_id}
                    onChange={() => {
                      handleSelectedReason(reasonType);
                      setRefundReasonValue({
                        reason_type_id: reasonType?.id,
                        reason_subtype_id: reasonType?.reason_subtypes[0]?.id,
                        reason_team: reasonType?.reason_subtypes[0]?.team,
                        reason_responsible_person: reasonType?.reason_subtypes[0]?.responsible_person,
                        reason_subtype_name: reasonType?.reason_subtypes[0]?.name || "",
                      });
                    }}
                    value={reasonType.id}
                    label={reasonType.name}
                  />
                  <div className="col-12" key={reasonType.id}>
                    {reasonType.id === values.refund_reason.reason_type_id &&
                      reasonType?.reason_subtypes.map((reasonSubType) => (
                        <div className="row ml-3" key={`${reasonType.id}-${reasonSubType.id}`}>
                          <RadioBox
                            selectedValue={selectedReasonSubType?.id}
                            onChange={() => {
                              handleSelectedReasonSubType(reasonSubType);
                              setRefundReasonValue({
                                reason_subtype_id: reasonSubType?.id,
                                reason_team: reasonSubType?.team,
                                reason_responsible_person: reasonSubType?.responsible_person,
                                reason_subtype_name: reasonSubType?.name || "",
                              });
                            }}
                            value={reasonSubType.id}
                            label={reasonSubType.name}
                          />
                          <div className="col-12" key={`comment-${reasonType.id}-${reasonSubType.id}`}>
                            {reasonSubType?.id === selectedReasonSubType?.id &&
                              reasonSubType?.is_comment_required && (
                                <div className={styles.reason_subtype_comment}>
                                  <TextArea
                                    label={`Please write what is the issue with the ${ selectedReasonSubType?.name }.`}
                                    rows={3}
                                    className="w-100"
                                    style={{ height: "90px", }}
                                    onChangeWithEvent={(e) => {
                                      setComment(e.target.value);
                                      setRefundReasonValue({ reason_message: e.target.value });
                                    }}
                                    id="reason_subtype_comment"
                                    error={ Boolean(error) && selectedReasonSubType?.is_comment_required && error }
                                    touched={ Boolean(error) && selectedReasonSubType?.is_comment_required && error }
                                    value={comment}
                                    disabled={false}
                                  />
                                </div>
                              )}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              ))}
            </div>
            <div className="row">
              <div className="col-12 my-3">
                <Button
                  onClick={submit}
                  variant="contained"
                  color="primary"
                  size="large"
                >
                  Next
                </Button>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default ModalWithReasons;
